import CheckProfile, { loader as checkProfileLoader } from './CheckProfile';

export default CheckProfile;
export { checkProfileLoader };
